export default "__VITE_ASSET__CUbgUN_X__"